export class Site {
  siteId: number;
  name: string;
  siteTypeId?: number;
  homeOfficeSiteId?: number;
  readOnly?: boolean;
  businessDate?: string;
  shortName?: string;
  attributes?: string;

  constructor(site?: Site) {
    if (site && site.siteId) {
      this.siteId = site.siteId;
      this.name = site.name;
      this.readOnly = site.readOnly;
      this.attributes = site.attributes;
    }
  }
}

/**
 * Helper function to check if a site is a test site
 * A site is considered a test site if its attributes contain "TEST"
 */
export function isTestSite(site: Site): boolean {
  return site.attributes?.toUpperCase().includes('TEST') ?? false;
}
